import * as React from 'react';
import ActionCenterTabs, { ActionCenterTab } from './tabs';
import { TabContent } from '../tab-styles';
import OpoMoveTracker from '../opo-move-tracker';
import OpoSwaps from '../opo-swaps';
import OpoCases from '../opo-cases';
import ToDoTab from './to-do/to-do-tab';
import { SettingsTab } from '../settings/tabs';

interface IProps {
    activeTab: string,
    onTabSelect: (tab: ActionCenterTab) => void,
    onSettingsSelect: (tab: SettingsTab) => void
}

const ActionCenterContent = ({ activeTab, onTabSelect, onSettingsSelect }: IProps) => {
    return (
        <>
            <ActionCenterTabs activeKey={activeTab} onSelect={onTabSelect} />

            <TabContent>
                {activeTab == ActionCenterTab.ToDo && (
                    <ToDoTab onTabSelect={onTabSelect} onSettingsSelect={onSettingsSelect} />
                )}

                {activeTab == ActionCenterTab.LivingDonorMoves && (
                    <OpoSwaps />
                )}

                {activeTab == ActionCenterTab.DeceasedDonorCases && (
                    <OpoCases />
                )}

                {activeTab == ActionCenterTab.MoveTracker && (
                    <OpoMoveTracker />
                )}
            </TabContent>
        </>
    );
};

export default ActionCenterContent;
